import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { INavigationProps } from '../common/defaults';
import { isGranted, isGrantedAny, permissions } from '../../../services/permissionChecker';
import { checkOnBaseStatus } from '../redux-objects/actions';

// @ts-ignore

interface IAppNavigationLocalState {
  farsDropdown: boolean;
  formsDropdown: boolean;
  adminDropdown: boolean;
  searchDropdown: boolean;
  workflowDropdown: boolean;
  reportsDropdown: boolean;
}

class AppNavigation extends React.Component<
  INavigationProps,
  IAppNavigationLocalState,
  any
> {
  constructor(props) {
    super(props);
    this.state = {
      farsDropdown: false,
      formsDropdown: false,
      adminDropdown: false,
      searchDropdown: false,
      workflowDropdown: false,
      reportsDropdown: false,
    };
  }

  updateHeaderAndCheckStatus = (header: string) => {
    this.props.updateHeaderOnNav(header);
    this.props.checkOnBaseStatus();
  }

  toggleFars = () => {
    this.setState({ farsDropdown: !this.state.farsDropdown });
    const element = document.getElementById('pointer-up-fars');
    element.classList.toggle('fa-angle-down');
    element.classList.toggle('fa-angle-up');
  };

  toggleForms = () => {
    this.setState({ formsDropdown: !this.state.formsDropdown });
    const element = document.getElementById('pointer-up-forms');
    element.classList.toggle('fa-angle-down');
    element.classList.toggle('fa-angle-up');
  };

  toggleAdmin = () => {
    if (this.props.isAdmin) {
      this.setState({ adminDropdown: !this.state.adminDropdown });
      const element = document.getElementById('pointer-up-admin');
      element.classList.toggle('fa-angle-down');
      element.classList.toggle('fa-angle-up');
    }
  };

  toggleSearch = () => {
    this.setState({
      searchDropdown: !this.state.searchDropdown,
    });
    const element = document.getElementById('pointer-up-search');
    element.classList.toggle('fa-angle-down');
    element.classList.toggle('fa-angle-up');
  };

  toggleWorkflow = () => {
    this.setState({
      workflowDropdown: !this.state.workflowDropdown,
    });
    const element = document.getElementById('pointer-up-workflow');
    element.classList.toggle('fa-angle-down');
    element.classList.toggle('fa-angle-up');
  };

  toggleReports = () => {
    this.setState({
      reportsDropdown: !this.state.reportsDropdown,
    });
    const element = document.getElementById('pointer-up-reports');
    element.classList.toggle('fa-angle-down');
    element.classList.toggle('fa-angle-up');
  };

  render() {
    const { currentUser } = this.props;
    return (
      <React.Fragment>
        <div className='page-logo'>
          <ul className='nav-menu'>
            <li>
              <Link
                to='/Dashboard'
                onClick={(e) => {
                  this.updateHeaderAndCheckStatus('Dashboard');
                }}
                className='waves-effect waves-themed navigate-home'
              >
                <section className='logo-container'>
                  <div className='logo-name'>
                    <h2>NCID</h2>
                  </div>
                  {this.props.onBaseIsUp && (
                  <div className='logo-image'>
                    <img src={require('./nebraska-icon.png')} alt='' />
                  </div>
                  )}
                  {!this.props.onBaseIsUp && (
                  <div className='logo-image'>
                    <img src={require('./nebraska-offline.png')} alt='' />
                  </div>
                  )}
                </section>
              </Link>
            </li>
          </ul>
        </div>

        <ul className='nav-menu js-nav-built' id='js-nav-menu'>
          {isGrantedAny([
            permissions.AdvancedSearch,
            permissions.CaseStudySearch,
            permissions.LicensePlateSearch,
            permissions.FlashlightSearchPrivate,
            permissions.FlashlightSearchPublic,
            permissions.DmvSearch,
            permissions.DuplicateSearch,
            permissions.WorkZoneSearch,
            permissions.GlobalSearch,
          ], currentUser) &&
            <li
              className='nav-title'
              onClick={() => {
                this.toggleSearch();
              }}
            >
              <i className='fas fa-search search-icon'> </i>
              Search Tools
              <span
                id='pointer-up-search'
                className='fa fa-angle-down float-right pointer'
              >
                {' '}
              </span>
            </li>
          }

          {this.state.searchDropdown && (
            <div className='farsDropdown'>
              {isGranted(permissions.AdvancedSearch, currentUser) &&
                <li>
                  <Link
                    to='/AdvancedSearch'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Advanced Search');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Advanced Search</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.CaseStudySearch, currentUser) &&
                <li>
                  <Link
                    to='/CaseStudySearch'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Case Study Search');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Case Study Search</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.LicensePlateSearch, currentUser) &&
                <li>
                  <Link
                    to='/LicensePlateLookupTool'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('License Plate Lookup Tool');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>License Plate Lookup</span>
                  </Link>
                </li>
              }

              {isGrantedAny([permissions.FlashlightSearchPrivate, permissions.FlashlightSearchPublic], currentUser) &&
                <li>
                  <Link
                    to='/ReportSearch'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Report Search');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Report Search</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.DmvSearch, currentUser) &&
                <li>
                  <Link
                    to='/DmvSearch'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('DMV Search');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>DMV Search</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.DuplicateSearch, currentUser) &&
                <li>
                  <Link
                    to='/DuplicateSearch'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Duplicate Search');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Duplicate Search</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.WorkZoneSearch, currentUser) &&
                <li>
                  <Link
                    to='/WorkZoneSearch'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Work Zone Search');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Work Zone Search</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.GlobalSearch, currentUser) &&
                <li>
                  <Link
                    to='/GlobalSearch'
                    onClick={() => {
                      this.updateHeaderAndCheckStatus('Global Search');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Global Search</span>
                  </Link>
                </li>
              }
            </div>
          )}

          {isGrantedAny([permissions.EditFars], currentUser) && (
            <>
              <li
                className='nav-title'
                onClick={() => {
                  this.toggleFars();
                }}
              >
                <i className='fas fa-heartbeat search-icon'> </i>
                FARS
                <span
                  id='pointer-up-fars'
                  className='fa fa-angle-down float-right pointer'
                >
                  {' '}
                </span>
              </li>

              {this.state.farsDropdown && (
                <div className='farsDropdown'>
                  {isGranted(permissions.EditFars, currentUser) &&
                    <li>
                      <Link
                        to='/ManageFARs'
                        onClick={(e) => {
                          this.updateHeaderAndCheckStatus('Manage FARs');
                        }}
                        className='waves-effect waves-themed'
                      >
                        <span className='nav-link-text'>Manage FARs</span>
                      </Link>
                    </li>
                  }
                </div>
              )}
            </>
          )}

          {this.props.isAdmin && (
            <li
              className='nav-title'
              onClick={() => {
                this.toggleForms();
              }}
            >
              <i className='fas fa-file-alt search-icon'> </i>
              Forms
              <span
                id='pointer-up-forms'
                className='fa fa-angle-down float-right pointer'
              >
                {' '}
              </span>
            </li>
          )}

          {this.state.formsDropdown && (
            <div className=''>
              {isGranted(permissions.EditFars, currentUser) &&
                <li>
                  <Link
                    to='/Fars'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('FARS Form');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>FARS</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.EditKeywords, currentUser) &&
                <li>
                  <Link
                    to='/Keywords'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Keywords');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Keywords</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.DataTranscribe, currentUser) &&
                <li>
                  <Link
                    to='/DataTranscriberForm'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Data Transcriber Form');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Data Transcriber</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.DataTranscribeValidation, currentUser) &&
                <li>
                  <Link
                    to='/DataTranscriberValidationForm'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus(
                        'Data Transcriber Validation Form'
                      );
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>
                      Data Transcriber Validation
                    </span>
                  </Link>
                </li>
              }

              {isGranted(permissions.DataEntry, currentUser) &&
                <li>
                  <Link
                    to='/GenericDataEntryForm'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Data Entry Form');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Data Entry Form</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.DataEntry, currentUser) &&
                <li>
                  <Link
                    to='/GenericDriverReportForm'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Driver Report Form');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Driver Report Form</span>
                  </Link>
                </li>
              }
            </div>
          )}

          {isGrantedAny([
            permissions.Letters,
            permissions.EditKeywords,
            permissions.DataTranscribe,
            permissions.DataTranscribeValidation,
            permissions.DataEntry,
            permissions.EditLocation,
            permissions.Reviewer,
            permissions.CheckerReview,
            permissions.MatchingQueue,
            permissions.ManagementQueue
          ], currentUser) &&
            <li
              className='nav-title'
              onClick={() => {
                this.toggleWorkflow();
              }}
            >
              <i className='fas fa-tasks search-icon'> </i>
              Workflow
              <span
                id='pointer-up-workflow'
                className='fa fa-angle-down float-right pointer'
              >
                {' '}
              </span>
            </li>
          }

          {this.state.workflowDropdown && (
            <div className=''>
              {isGranted(permissions.Letters, currentUser) &&
                <li>
                  <Link
                    to='/Notifications'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Letters');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Letters</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.EditKeywords, currentUser) &&
                <li>
                  <Link
                    to='/KeywordQueue'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Keywords');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Keywords</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.DataTranscribe, currentUser) &&
                <li>
                  <Link
                    to='/DataTranscribeQueue'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Transcriber');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Transcriber</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.DataTranscribeValidation, currentUser) &&
                <li>
                  <Link
                    to='/DataTranscriberValidationQueue'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus(
                        'Transcriber Validation'
                      );
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>
                      Transcriber Validation
                    </span>
                  </Link>
                </li>
              }

              {isGranted(permissions.DataEntry, currentUser) &&
                <li>
                  <Link
                    to='/DataEntryQueue'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Data Entry');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Data Entry</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.EditLocation, currentUser) &&
                <li>
                  <Link
                    to='/LocationMapping'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Location Mapping');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Location Mapping</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.Reviewer, currentUser) &&
                <li>
                  <Link
                    to='/LocationReview'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Location Review');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Location Review</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.CheckerReview, currentUser) &&
                <li>
                  <Link
                    to='/Checkers'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Checkers');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Checkers</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.MatchingQueue, currentUser) &&
                <li>
                  <Link
                    to='/MatchingQueue'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Matching');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Matching</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.ManagementQueue, currentUser) &&
                <li>
                  <Link
                    to='/ManagementQueue'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Management');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Management</span>
                  </Link>
                </li>
              }
            </div>
          )}

          {this.props.isAdmin && (
            <li
              className='nav-title'
              onClick={() => {
                this.toggleAdmin();
              }}
            >
              <i className='fas fa-user search-icon'> </i>
              Administration
              <span
                id='pointer-up-admin'
                className='fa fa-angle-down float-right pointer'
              >
                {' '}
              </span>
            </li>
          )}
          {this.state.adminDropdown && (
            <div className=''>
              {isGranted(permissions.Developer, currentUser) &&
                <li>
                  <Link
                    to='/HealthDashboard'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Health Dashboard');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Health Dashboard</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.AuditLog, currentUser) &&
                <li>
                  <Link
                    to='/AuditLogs'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Audit Logs');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Audit Logs</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.EditLetterTemplates, currentUser) &&
                <li>
                  <Link
                    to='/NotificationTemplates'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Letter Templates');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Letter Templates</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.LookupTypesAdmin, currentUser) &&
                <li>
                  <Link
                    to='/LookupTypesAdmin'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Lookup Types');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Lookup Types Admin</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.RedactFields, currentUser) &&
                <li>
                  <Link
                    to='/RedactedFields'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Redacted Fields');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Redacted Fields Admin</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.FormAdmin, currentUser) &&
                <li>
                  <Link
                    to='/FormAdmin'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Form Administration');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Form Admin</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.FormAdmin, currentUser) &&
                <li>
                  <Link
                    to='/FormFieldHistory'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Form Field Change History');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Form Field History</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.PrintReportSample, currentUser) &&
                <li>
                  <Link
                    to='/PrintPDF'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Print PDF');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Print Report Sample</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.ManageVendors, currentUser) &&
                <li>
                  <Link
                    to='/VendorTabContainer'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Manage Vendors');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Manage Vendors</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.Extracts, currentUser) &&
                <li>
                  <Link
                    to='/ExtractsAdmin'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Extract Administration');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Extracts</span>
                  </Link>
                </li>
              }

              {this.props.isAdmin &&
                <li>
                  <Link
                    to='/ImportExport'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Import/Export');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Import/Export</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.RoleAdmin, currentUser) &&
                <li>
                  <Link
                    to='/RoleAdmin'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Role Administration');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Role Admin</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.AddEditUser, currentUser) &&
                <li>
                  <Link
                    to='/UserAdmin'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('User Administration');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>User Admin</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.ManageWorkflow, currentUser) &&
                <li>
                  <Link
                    to='/Workflow'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Workflow Administration');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Workflow Admin</span>
                  </Link>
                </li>
              }

              {isGranted(permissions.ReportChainEditor, currentUser) &&
                <li>
                  <Link
                    to='/ReportChainEditor'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Report Chain Editor');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Report Chain Editor</span>
                  </Link>
                </li>
              }
            </div>
          )}

          {isGrantedAny([permissions.PowerBIViewReport, permissions.PowerBIViewAllReports], currentUser) &&
            <li
              className='nav-title'
              onClick={() => {
                this.toggleReports();
              }}
            >
              <i className='fa fa-file-text search-icon'> </i>
              Reports
              <span
                id='pointer-up-reports'
                className='fa fa-angle-down float-right pointer'
              >
                {' '}
              </span>
            </li>
          }
          {this.state.reportsDropdown && (
            <div className='farsDropdown'>
              {isGrantedAny([permissions.PowerBIViewReport, permissions.PowerBIViewAllReports], currentUser) &&
                <li>
                  <Link
                    to='/PowerBiReports'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Reports');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Power BI Reports</span>
                  </Link>
                </li>
              }
              {isGranted(permissions.StandardSummary, currentUser) &&
                <li>
                  <Link
                    to='/StandardSummary'
                    onClick={(e) => {
                      this.updateHeaderAndCheckStatus('Standard Summary');
                    }}
                    className='waves-effect waves-themed'
                  >
                    <span className='nav-link-text'>Standard Summary</span>
                  </Link>
                </li>
              }
            </div>
          )}
        </ul>
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    onBaseIsUp: state.Navigation.onBaseIsUp
  };
}

const mapDispatchToProps = {
  checkOnBaseStatus
};

export default connect(mapStateToProps, mapDispatchToProps)(AppNavigation);